module.exports = __webpack_public_path__ + "img/znfy.71f2a6e4.png";